import { IShoppingItem } from '@inter-ikea-kompis/types/lib';
import { getInsightsItems } from '../../../../util/aactools/kompisConvert';
import { getInsiktReporter } from '../../analytics';
import mandatoryStatisticsActions from './mandatoryStatisticsActions';
import {
  DesignInteractionEnum,
  DesignSourceEnum,
} from '@insights/insights-data-provider';
interface MandatoryEvent {
  reportEvent: Function;
}
interface MandatoryEvents {
  [key: string]: MandatoryEvent;
}
const insiktReporter = getInsiktReporter();
const getInsightsApi = () => insiktReporter.getInsightsApi();

/**
 * The mandatory events that are required to be reported according to the insights documentation.
 * @link https://i-p-e-x.atlassian.net/wiki/spaces/IPEX/pages/890536089/Data+Provider+Component
 */
export const mandatoryEvents: MandatoryEvents = {
  [mandatoryStatisticsActions.ADD_TO_CART]: {
    reportEvent: async (payload: IShoppingItem[]) => {
      if (await insiktReporter.canTransmit()) {
        const items = getInsightsItems(payload);
        getInsightsApi().addToCart(items);
      }
    },
  },
  [mandatoryStatisticsActions.ADD_TO_WISHLIST]: {
    reportEvent: async (payload: IShoppingItem[]) => {
      if (await insiktReporter.canTransmit()) {
        const items = getInsightsItems(payload);
        getInsightsApi().addToWishList(items);
      }
    },
  },
  [mandatoryStatisticsActions.INIT_PLANNING_SESSION]: {
    reportEvent: async (vpcCode: string, vpcSource: DesignSourceEnum) => {
      (await insiktReporter.canTransmit()) &&
        getInsightsApi().initPlanningSession(vpcCode, vpcSource);
    },
  },
  [mandatoryStatisticsActions.SEND_DESIGN_INTERACTION_EVENT]: {
    reportEvent: async (
      designId: string,
      vpcInteraction: DesignInteractionEnum
    ) => {
      (await insiktReporter.canTransmit()) &&
        getInsightsApi().sendDesignInteractionEvent(designId, vpcInteraction);
    },
  },
};

export const getMandatoryEvent = (mandatoryEventType: string) => {
  return mandatoryEvents[mandatoryEventType];
};
